import PortfolioItem from './PortfolioItem';
import '../styles/PortfolioPage.scss';

function PortfolioPage() {
  const portfolioItems = [
    {
      type: 'experience',
      name: 'Shin Tax Solutions',
      description: "A responsive, client-focused website for a tax firm, designed for clear communication and aligned with the firm’s branding",
      features: [
        'Calendly integration for convenient scheduling',
        'PayPal integration for secure and seamless payments',
        'Contact form for quick and easy inquiries',
      ],
      techStack: [
        'React.js',
        'Email.js',
        'SCSS', 
        'PayPal SDK',
        'Google Analytics', 
        'Vercel'
      ],
      images: [
        '/images/sts-1.jpeg',
        '/images/sts-2.jpeg',
        '/images/sts-3.jpeg',
        '/images/sts-4.jpeg',
        '/images/sts-5.jpeg',
        '/images/sts-6.jpeg',
        '/images/sts-7.jpeg',
      ],
      button: 'Visit Site',
      link: 'https://www.shintaxsolutions.com/'
    },
    {
      type: 'experience',
      name: 'Vueable Query',
      description: 'Open source developer tool that reports on Tanstack Query activities and performance metrics for Vue.js apps',
      features: [
        'a timeline to visualize query history', 
        'a text panel to display all relevant queries under their query key',
        'highlighting on click and hover',
        'tool tip displayed on hover'
      ],
      techStack: [
        'Vue.js',
        'Pinia',
        'D3.js',
        'SCSS'
      ],
      images: [
        '/images/vueable-query-2.png',
        '/images/vueable-query-3.png'
      ],
      button: 'View GitHub Repo',
      link: 'https://github.com/oslabs-beta/Vueable-query'
    },
    {
      type: 'project',
      name: 'Dine',
      description: 'A restaurant web app that allows customers to create an account and make reservations',
      features: [
        'create a user account', 
        'book a reservation',
        'view and delete reservations',
        'receive error messages if register form fields are blank, log in fields are incorrect, and/or reservation time and date are invalid'
      ],
      techStack: [
        'React.js',
        'SCSS',
        'REST API',
        'Express.js',
        'PostgreSQL'
      ],
      images: [
        '/images/dine-1.png',
        '/images/dine-2.png',
        '/images/dine-3.png',
        '/images/dine-4.png',
        '/images/dine-5.png',
        '/images/dine-6.png',
        '/images/dine-7.png',
        '/images/dine-8.png',
        '/images/dine-9.png'
      ],
      button: 'View GitHub Repo',
      link: 'https://github.com/annaduong17/restaurant-website'
    },
    {
      type: 'project',
      name: 'Todo App',
      description: 'A classic todo app with dark/light theme toggle',
      features: [
        'add, edit, and delete todos', 
        'filter for active and completed todos',
        'clear completed todos',
        'toggle theme'
      ],
      techStack: [
        'React.js',
        'SCSS',
        'REST API',
        'Express.js',
        'MongoDB'
      ],
      images: [
        '/images/todo-app-1.png',
        '/images/todo-app-2.png',
        '/images/todo-app-3.png',
        '/images/todo-app-4.png'
      ],
      button: 'View Github Repo',
      link: 'https://github.com/annaduong17/todo-app'
    },
    {
      type: 'project',
      name: 'E-commerce App',
      description: 'An app that displays shoes for sale',
      features: [
        'Open a lightbox gallery by clicking on the large product image', 
        'Switch the large product image by clicking on the small thumbnail images',
        'Add items to the cart and delete items',
        'Cart icon updates with total number of items'
      ],
      techStack: [
        'React.js',
        'SCSS'
      ],
      images: [
        '/images/e-commerce-1.png',
        '/images/e-commerce-2.png',
        '/images/e-commerce-3.png',
        '/images/e-commerce-4.png'
      ],
      button: 'View Github Repo',
      link: 'https://github.com/annaduong17/e-commerce'
    },
    {
      type: 'project',
      name: 'Expenses Chart',
      description: 'A component that visualizes weekly spending using a bar graph',
      features: [
        'View the bar chart and hover over the individual bars to see the correct amounts for each day', 
        'See the bar with the highest amount highlighted in a different color to the other bars',
        'See the selected bar\'s opacity change on hover',
        'See dynamically generated bar heights based on the data in the local JSON file'
      ],
      techStack: [
        'React.js',
        'SCSS'
      ],
      images: [
        '/images/expenses-chart-1.png',
        '/images/expenses-chart-2.png'
      ],
      button: 'View Github Repo',
      link: 'https://github.com/annaduong17/expenses-chart'
    },
    {
      type: 'project',
      name: 'Age Calculator',
      description: 'An app that calculates the current age based on provided birthdate',
      features: [
        'View an age in years, months, and days after submitting a valid date through the form', 
        'Receive validation errors if any field is empty when the form is submitted',
        'Receive validation errors if the day number is not between 1-31',
        'Receive validation errors if the month number is not between 1-12', 
        'Receive validations errors if the date is in the future'
      ],
      techStack: [
        'React.js',
        'SCSS'
      ],
      images: [
        '/images/age-calculator-1.png',
        '/images/age-calculator-2.png'
      ],
      button: 'View Github Repo',
      link: 'https://github.com/annaduong17/age-calculator'
    },
    {
      type: 'project',
      name: 'FAQ Accordion',
      description: 'A page that displays frequently asked questions and answers',
      features: [
        'Hide/show the answer to a question when the question is clicked', 
        'Only one answer is open at a time',
        'Navigate the questions and hide/show answers using keyboard navigation alone'
      ],
      techStack: [
        'React.js',
        'SCSS'
      ],
      images: [
        '/images/faq-accordion-1.png',
        '/images/faq-accordion-2.png'
      ],
      button: 'View Github Repo',
      link: 'https://github.com/annaduong17/faq-accordion'
    },
  ]

  const renderedItems = portfolioItems.map((item, index) => {
    return (
        <PortfolioItem
          key={index}
          type={item.type} 
          name={item.name}
          description={item.description}
          features={item.features}
          techStack={item.techStack}
          images={item.images}
          button={item.button}
          link={item.link}
        />
    )
  });

  return (
    <div id='portfolio-page' className='portfolio-page page-margin page-padding'>
      <h2 className='heading'>Projects</h2>
      <div className='projects flex-wrap'>
        {renderedItems}
      </div>
    </div>
  );
}

export default PortfolioPage;